import React from 'react';
import ForgotPassword from '../components/auth/ForgotPassword';

export default function ForgotPasswordPage() {
  return <ForgotPassword />;
}

